import { GuidService } from 'ui-components/services/guid-service';
import { printScanToPrintLabelRequest } from '../../../store/scan-to-print/s2p-purchase-and-print.actions';
import Global from '../../../store/global-selectors';
import { ScanToPrintReader } from '../../../store/scan-to-print/scan-to-print-reader';

export default (state, jobId) => {
  const requestId = GuidService.newGuid();
  const { printer } = new ScanToPrintReader({ state });
  const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
  const { fulfillmentPlanId, fulfillments } = jobData;
  const printUrl = `/api/download/label/${fulfillments.join(',')}`;
  const printJob = {
    requestId,
    printer,
    documentType: 'label',
    ids: fulfillments,
    fulfillmentPlanIds: [fulfillmentPlanId],
    templateId: 0, // ????
    printUrl,
  };
  return [printScanToPrintLabelRequest(printJob, jobId)];
};
